import * as React from "react";
import { AiChatAssistantRole } from "app/components/ai-chat-assistant/types";
import styles from "app/components/ai-chat-assistant/styles.scss";

export const ChatMessages = ({
  messages,
  running,
  endRef,
  translation
}: {
  messages: any[];
  running: boolean;
  endRef: any;
  translation: Record<string, string>;
}) => {
  const getFallback = (isAiChatAssistantRole: boolean) => {
    if (!isAiChatAssistantRole) { return "" }

    if (running) { return translation.textThinking }
    return "";
  };

  return (
    <div className={styles.chatBody}>
      {messages.map((m) => {
        const content = (m.content ?? "").trim();
        const isAiChatAssistantRole = m.role === AiChatAssistantRole.Assistant;
        const displayText = content || getFallback(isAiChatAssistantRole);

        if (!displayText) { return null }

        return (
          <div
            className={`${styles.msgText} ${isAiChatAssistantRole ? styles.assistantMsg : styles.userMsg
              }`}
            key={m.id}
          >
            {displayText}
          </div>
        );
      })}
      <div ref={endRef} />
    </div>
  );
};
